import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout1 from "../../Layouts/Layout1";
import LayoutContainer from "../../Layouts/LayoutContainer";
import { ChevronLeft, HelpCircle } from "lucide-react";
import RentalDataUseModal from "./RentalDataUseModal";
import { useRentalProfile } from "../../context/RentalProfileContext";
import { RENTAL_PROFILE_SECTIONS } from "../../Constants/rentalProfile";

const HouseholdPeople = () => {
  const navigate = useNavigate();
  const { profile, loading, saving, updateSection } = useRentalProfile();
  const [dataUseModalOpen, setDataUseModalOpen] = useState(false);
  const [liveWithOthers, setLiveWithOthers] = useState("yes");
  const [occupants, setOccupants] = useState([]);

  useEffect(() => {
    if (loading) return;
    setLiveWithOthers(profile.householdPeople.liveWithOthers || "yes");
    setOccupants(profile.householdPeople.occupants || []);
  }, [loading, profile.householdPeople]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const ok = await updateSection(RENTAL_PROFILE_SECTIONS.HOUSEHOLD_PEOPLE, {
      liveWithOthers,
      occupants,
    });
    if (ok) navigate("/rental-applications");
  };

  const segBtn = (key) =>
    `flex-1 rounded-full py-3 text-sm font-semibold transition-all ${
      liveWithOthers === key
        ? "bg-[#000929] text-white shadow-md"
        : "bg-transparent text-[#000929]"
    }`;

  return (
    <Layout1>
      <LayoutContainer className="max-w-xl py-8 md:py-12 lg:py-14">
        <button
          type="button"
          onClick={() => navigate("/rental-applications")}
          className="mb-4 inline-flex items-center gap-1 text-sm font-medium text-[#097FE6] hover:underline"
        >
          <ChevronLeft className="h-4 w-4" strokeWidth={2} />
          Back
        </button>

        <h1 className="text-2xl font-bold tracking-tight text-[#000929] md:text-3xl">
          People
        </h1>

        <div className="mt-8 rounded-xl border border-[#E5E7EB] bg-white p-6 shadow-sm md:p-8">
          <form onSubmit={handleSubmit} className="space-y-8">
            <div>
              <h2 className="text-base font-semibold text-[#000929]">
                Will you live with other occupants who are not on the lease?
              </h2>
              <div className="mt-5 flex w-full rounded-full bg-[#F3F4F6] p-1 shadow-sm">
                <button
                  type="button"
                  onClick={() => setLiveWithOthers("yes")}
                  className={segBtn("yes")}
                >
                  Yes
                </button>
                <button
                  type="button"
                  onClick={() => setLiveWithOthers("no")}
                  className={segBtn("no")}
                >
                  No
                </button>
              </div>
            </div>

            <div className="border-t border-[#E5E7EB] pt-8">
              <button
                type="submit"
                disabled={loading || saving}
                className="w-full rounded-lg bg-[#097FE6] py-3 text-sm font-semibold text-white transition-colors hover:bg-[#0868c4] disabled:cursor-not-allowed disabled:opacity-60"
              >
                {saving ? "Saving…" : "Save and back"}
              </button>
              <div className="mt-4 text-center">
                <button
                  type="button"
                  onClick={() => navigate("/rental-applications")}
                  className="text-sm font-semibold text-[#000929] hover:underline"
                >
                  Cancel
                </button>
              </div>
            </div>
          </form>
        </div>

        <button
          type="button"
          onClick={() => setDataUseModalOpen(true)}
          className="mt-10 inline-flex items-center gap-2 text-sm text-[#6B7280] underline decoration-[#6B7280] underline-offset-2 hover:text-[#1A1A1A]"
        >
          <HelpCircle className="h-4 w-4 shrink-0" strokeWidth={2} />
          How this information is used
        </button>
      </LayoutContainer>

      <RentalDataUseModal
        variant="personalDetails"
        open={dataUseModalOpen}
        onClose={() => setDataUseModalOpen(false)}
      />
    </Layout1>
  );
};

export default HouseholdPeople;
